import { IRevenueAgencyCrudModalLang } from '../../../types/lang'

export const revenueAgencyCrudModalLang: IRevenueAgencyCrudModalLang = {
	revenue_agency_crud_modal: {
		title_create: 'Create revenue agency',
		title_edit: 'Edit revenue agency',
		title_remove_single: 'Remove <span>revenue agency</span>',
		title_notes_view: 'View notes for revenue agency',
		title_notes_edit: 'Edit notes for revenue agency',
		title_history_view: 'View history in revenue agency',
		field_name_label: 'Name',
		field_name_placeholder: 'Name',
		field_group_label: 'Group',
		field_group_placeholder: 'Group',
		field_fake_type_label: 'Fake Type',
		field_fake_type_placeholder: 'Fake Type',
		field_date_label: 'Date',
		field_date_placeholder: 'Date',
		field_percent_label: 'Percent, %',
		field_percent_placeholder: 'Percent, %',
		field_is_system_label: 'System',
		field_is_active_label: 'Active',
		field_is_hold_label: 'Hold',
		field_notes_label: 'Notes',
		field_notes_placeholder: 'Notes',
		msg_remove_confirm: 'Are you sure?',
		btn_add_record: 'Add Record',
		btn_create: 'Create',
		btn_update: 'Save',
		btn_remove: 'Remove',
		btn_close: 'Close'
	}
}